.menuItem {
  width: 50%;
  padding-left: 15px;
  font-size: 13px;
  line-height: 37px;
}

.menuList {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #e0e0e0;
}

.actionItem {
  width: 50%;
  padding-left: 15px;
  font-size: 13px;
  line-height: 50px;
}

.recommendList {
  padding: 15px 0 0 15px;
  border-bottom: 1px solid #e0e0e0;
}

.recommendTitle {
  font-size: var(--font-size-sm);
}

.recommendItem {
  width: 100%;
  font-size: var(--font-size-sm);
  line-height: 37px;
}

.customLink {
  color: #326891;
}
